export default __webpack_public_path__ + "static/media/spinner-blue-full.2301f373.gif";